export enum AlertType {
  Alert = 1,
  Confirm = 2,
  Prompt = 3,
}
